module.exports = __webpack_public_path__ + "img/logo.ae4320fb.png";